module.exports = __webpack_public_path__ + "static/img/萌龙龙.58559483.png";